import { render, staticRenderFns } from "./supInfo.vue?vue&type=template&id=399f71f6&scoped=true"
import script from "./supInfo.vue?vue&type=script&lang=js"
export * from "./supInfo.vue?vue&type=script&lang=js"
import style0 from "./supInfo.vue?vue&type=style&index=0&id=399f71f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f71f6",
  null
  
)

export default component.exports